import styled from '@emotion/styled';
import { breakpoints, gutterSizes, mediaQuery } from '@gumtree/ui-library/src/base/theme';

export const StyledTagsList = styled.div`
    display: flex;
    grid-gap: ${gutterSizes.base};
    margin-top: ${gutterSizes.medium};

    ${mediaQuery.until(breakpoints.small)} {
        overflow-x: auto;
    }

    ${mediaQuery.from(breakpoints.small)} {
        flex-wrap: wrap;
    }
`;
